export default "__VITE_ASSET__DWcqa8Y3__"